export const isPageHidden = (pageKey, hiddenPages = []) => {
    return hiddenPages.includes(pageKey);
};